<p-dialog
	[(visible)]="applicationId"
	(onHide)="applicationClose()"
	*ngIf="application"
	[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
	[style]="{ width: '50vw' }"
>
	<div class="d-flex flex-column">
		<div class="display-10">
			Partner App ID: <span class="display-12">{{ application.partnerId || "Not submitted" }}</span>
		</div>
		<div class="display-10">
			Status: <span class="display-12">{{ application.partnerApplicationStatusLabel || "Unsubmitted" }}</span>
		</div>
	</div>
	<ng-container *ngFor="let res of underwritingResult">
		<div class="p-grid border">
			<div class="p-col">
				<div class="h4">{{ res.categoryLabel }}</div>
			</div>
			<div class="p-col">
				<div *ngFor="let service of res.results" class="mb-1">
					<div class="p-grid">
						<div class="p-col">
							<div class="">{{ service.label }}</div>
						</div>
						<div class="p-col d-flex justify-content-end">
							<p-tag *ngIf="service.status === 0" value="Not Checked" severity="info"></p-tag>
							<p-tag *ngIf="service.status === 1" value="Good" severity="success"></p-tag>
							<p-tag *ngIf="service.status === 2" value="Warning" severity="warning"></p-tag>
							<p-tag *ngIf="service.status === 3" value="Danger" severity="danger"></p-tag>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</p-dialog>
